import type { ClassificationSource, ConfidenceBand } from '../api/workItems';

export const CONFIDENCE_BAND_LABELS: Record<ConfidenceBand, string> = {
  none: 'No confidence',
  zero: 'Zero confidence',
  low: 'Low confidence',
  medium: 'Medium confidence',
  high: 'High confidence',
};

export const CLASSIFICATION_SOURCE_LABELS: Record<ClassificationSource, string> = {
  heuristic: 'Heuristic rules',
  ai_enrichment: 'AI enrichment',
  user_override: 'Your correction',
  bulk_user_approved: 'Bulk-approved change',
  migration: 'Migration',
  system_default: 'System default',
  unknown: 'Unknown',
};

export function confidenceBandLabel(band: string | null | undefined): string {
  if (!band) return CONFIDENCE_BAND_LABELS.none;
  return CONFIDENCE_BAND_LABELS[band as ConfidenceBand] ?? band;
}

export function classificationSourceLabel(source: string | null | undefined): string {
  if (!source) return CLASSIFICATION_SOURCE_LABELS.unknown;
  return CLASSIFICATION_SOURCE_LABELS[source as ClassificationSource] ?? CLASSIFICATION_SOURCE_LABELS.unknown;
}

export function formatConfidenceDistribution(
  distribution: Record<string, number | undefined>,
): string {
  const order: ConfidenceBand[] = ['high', 'medium', 'low', 'zero', 'none'];
  return order
    .filter((band) => (distribution[band] ?? 0) > 0)
    .map((band) => `${CONFIDENCE_BAND_LABELS[band]}: ${distribution[band] ?? 0}`)
    .join(' · ');
}
